<template>
  <div class="plane-detail-page" :class="{ isiOSX: isiOSX }">
    <van-row class="detailTitle">
      <img @click="reBack" class="back" src="../../assets/plane/reBack.png" />
      <van-col class="target" span="24">
        {{ listObj.departure_city_name }}
        <img src="../../assets/plane/target@2x.png" />
        {{ listObj.arrive_city_name }}
      </van-col>
      <span class="que" @click="question">常见问题</span>
    </van-row>
    <div class="content">
      <!--无经停信息-->
      <van-row class="msg" v-if="listObj.stop_num == 0">
        <van-col span="24" class="flight flex-box">
          <p class="title">
            <img :src="listObj.air_comImage_url" />
            {{ listObj.airline_company + " " + listObj.flight_no }}
          </p>
          <p class="title middle">
            {{ listObj.craft_type_name || listObj.craft_type }}
            <span v-if="listObj.plane_model"
              >(<span v-if="listObj.plane_model == 1">大</span
              ><span v-if="listObj.plane_model == 2">中</span
              ><span v-if="listObj.plane_model == 3">小</span
              ><span v-if="listObj.plane_model == 0">其他</span>)</span
            >
            <span v-else>(其他)</span>
          </p>
          <p class="title right">{{ getDate(listObj.departure_date) }}</p>
        </van-col>
        <van-col class="flight" span="9">
          <p class="time">{{ listObj.departure_time }}</p>
          <p class="space">
            {{ listObj.departure_port_came + listObj.departure_terminal }}
          </p>
        </van-col>
        <van-col class="flight" span="6">
          <p class="time">
            <img src="../../assets/plane/targetL@2x.png" />
          </p>
          <p class="duration">约{{ listObj.flight_time1 }}</p>
        </van-col>
        <van-col class="flight" span="9">
          <p class="time">{{ listObj.arrive_time }}</p>
          <p class="space">
            {{ listObj.arrive_port_name + listObj.arrive_terminal }}
          </p>
        </van-col>
        <van-col class="tip" span="24">
          {{ listObj.meal_name || "无餐" }}
          <span class="line"></span>
          {{ listObj.craft_type_name || listObj.craft_type }}
          <span v-if="listObj.plane_model"
            >(<span v-if="listObj.plane_model == 1">大</span
            ><span v-if="listObj.plane_model == 2">中</span
            ><span v-if="listObj.plane_model == 3">小</span
            ><span v-if="listObj.plane_model == 0">其他</span>)</span
          >
          <span v-else>(其他)</span>
          <span class="line"></span>准点率{{ listObj.on_time_rate }}
        </van-col>
      </van-row>
      <!--有经停信息-->
      <van-row class="msg msg_stop" v-if="listObj.stop_num != 0">
        <van-col span="24" class="title"
          ><span v-if="!listObj.stop_points[0].flight_no1">经停</span
          ><span v-if="listObj.stop_points[0].flight_no1">通程</span>
          <span class="date">{{ getDate(listObj.departure_date) }}</span>
          <span class="duration">{{ listObj.flight_time1 }}</span></van-col
        >
        <van-col span="24" class="interval">
          <div class="box">
            <img class="line" src="../../assets/plane/line_top.png" />
            <p class="tit">
              <span class="time">{{ listObj.departure_time }}</span
              >{{ listObj.departure_port_came + listObj.departure_terminal }}
            </p>
            <p class="info">
              <img :src="listObj.air_comImage_url" />{{
                listObj.airline_company + " " + listObj.flight_no
              }}
              <span
                >{{ listObj.craft_type_name || listObj.craft_type }}
                <span v-if="listObj.plane_model"
                  >(<span v-if="listObj.plane_model == 1">大</span
                  ><span v-if="listObj.plane_model == 2">中</span
                  ><span v-if="listObj.plane_model == 3">小</span
                  ><span v-if="listObj.plane_model == 0">其他</span>)</span
                >
                <span v-else>(其他)</span>
              </span>
            </p>
          </div>
        </van-col>
        <van-col
          span="24"
          class="interval"
          v-for="(item, index) in listObj.stop_points"
          :key="index"
        >
          <div class="box">
            <img class="line" src="../../assets/plane/line_m2.png" />
            <p class="tit">
              <span class="time">{{ timeCheck(item.arrival_time) }}</span
              >{{ item.air_port_name }}
            </p>
            <p class="point">
              <span v-if="!listObj.stop_points[0].flight_no1">经停</span
              ><span v-if="listObj.stop_points[0].flight_no1">通程</span
              >{{ item.air_port_name }}{{ item.duration }}分钟
            </p>
          </div>
          <div class="box">
            <img class="line" src="../../assets/plane/line_m1.png" />
            <p class="tit">
              <span class="time">{{ timeCheck(item.departure_time) }}</span
              >{{ item.air_port_name }}
            </p>
            <p class="info">
              <img :src="listObj.air_comImage_url" />{{
                listObj.airline_company + " " + listObj.flight_no
              }}
              <span
                >{{ listObj.craft_type_name || listObj.craft_type }}
                <span v-if="listObj.plane_model"
                  >(<span v-if="listObj.plane_model == 1">大</span
                  ><span v-if="listObj.plane_model == 2">中</span
                  ><span v-if="listObj.plane_model == 3">小</span
                  ><span v-if="listObj.plane_model == 0">其他</span>)</span
                >
                <span v-else>(其他)</span>
              </span>
            </p>
          </div>
        </van-col>
        <van-col span="24" class="interval">
          <div class="box last">
            <img class="circle" src="../../assets/plane/circle.png" />
            <p class="tit">
              <span class="time t1">{{ getDate(listObj.arrive_date) }}</span
              ><span class="time">{{ listObj.arrive_time }}</span
              >{{ listObj.arrive_port_name + listObj.arrive_terminal }}
            </p>
          </div>
        </van-col>
        <van-col class="tip" span="24">
          {{ listObj.meal_name || "无餐" }}
          <span class="line"></span>
          {{ listObj.craft_type_name || listObj.craft_type }}
          <span v-if="listObj.plane_model"
            >(<span v-if="listObj.plane_model == 1">大</span
            ><span v-if="listObj.plane_model == 2">中</span
            ><span v-if="listObj.plane_model == 3">小</span
            ><span v-if="listObj.plane_model == 0">其他</span>)</span
          >
          <span v-else>(其他)</span>
          <span class="line"></span>准点率{{ listObj.on_time_rate }}
        </van-col>
      </van-row>

      <van-row
        class="list"
        v-for="(item, index) in cabinList"
        :key="index"
        v-if="
          cabin == 0 ||
          (cabin == 1 && item.cabin_type == '经济舱') ||
          (cabin == 2 && item.cabin_type == '公务舱') ||
          (cabin == 3 && item.cabin_type == '头等舱')
        "
      >
        <van-col class="left" span="19">
          <p
            class="price"
            v-for="list in item.price_list"
            v-if="list.psg_type == 'ADT'"
          >
            <span class="label">￥</span>
            <span class="money">{{ list.price }}</span>
            <span class="style">成人</span>
            <span class="style" v-if="item.draw_ticket_time > 0"
              >{{ toHourMinute(item.draw_ticket_time) }}内出票</span
            >
            <span class="style" v-if="item.draw_ticket_time < 0"
              >起飞前{{
                toHourMinute(Math.abs(item.draw_ticket_time))
              }}出票</span
            >
            <!-- <span class="return">返</span> -->
          </p>
          <p
            class="price"
            v-for="list in item.price_list"
            v-if="list.psg_type == 'CHD' && child_show"
          >
            <span class="label">￥</span>
            <span class="money">{{ list.price }}</span>
            <span class="style">儿童</span>
            <span class="style" v-if="item.draw_ticket_time > 0"
              >{{ toHourMinute(item.draw_ticket_time) }}内出票</span
            >
            <span class="style" v-if="item.draw_ticket_time < 0"
              >起飞前{{
                toHourMinute(Math.abs(item.draw_ticket_time))
              }}出票</span
            >
            <!-- <span class="return">返</span> -->
          </p>
          <p
            class="price"
            v-for="list in item.price_list"
            v-if="list.psg_type == 'INF' && baby_show"
          >
            <span class="label">￥</span>
            <span class="money">{{ list.price }}</span>
            <span class="style">婴儿</span>
            <span class="style" v-if="item.draw_ticket_time > 0"
              >{{ toHourMinute(item.draw_ticket_time) }}内出票</span
            >
            <span class="style" v-if="item.draw_ticket_time < 0"
              >起飞前{{
                toHourMinute(Math.abs(item.draw_ticket_time))
              }}出票</span
            >
            <!-- <span class="return">返</span> -->
          </p>
          <p class="tip">
            {{ item.discount_rate
            }}<b v-if="item.cabin_type == '公务舱'">商务舱</b
            ><b v-else>{{ item.cabin_type }}</b> |
            <span @click="luggageRule(item.baggage_info)">免费行李规定 ></span>
            <span class="tickets">余{{ item.cabin_number }}张</span>
          </p>
        </van-col>
        <van-col
          class="right"
          span="5"
          :class="[
            item.price_list.length == 3 && price_list3 ? activeClassF : '',
          ]"
        >
          <span
            :class="[
              item.price_list.length >= 2 && price_list2 ? activeClass : '',
            ]"
            @click="destine(item)"
            >预订</span
          >
        </van-col>
      </van-row>
      <div class="loading" v-if="cabinList.length <= 0 && hascabin">
        <img src="../../assets/common/loading.gif" />
      </div>
      <van-row class="empty_list" v-if="!hascabin">
        <van-col class="emptyMsg" span="24">
          <img src="../../assets/plane/noOrder.png" />
          <p class="tip1" v-if="!timeout">暂无相关航班</p>
          <p class="tip1" v-if="timeout"></p>
          <p class="btn">
            <span @click="reBack">返回</span>
          </p>
        </van-col>
      </van-row>
    </div>
    <van-popup v-model="luggagePop" position="bottom" :overlay="true">
      <img
        class="close"
        @click="closePopup"
        src="../../assets/plane/close-icon@2x.png"
      />
      <van-row class="popBox">
        <van-col class="title" span="24">免费行李规定</van-col>
        <van-col class="tip" span="24"
          >若您在机场以外发生行李丢失或延迟，请及时联系销巴生活客服，我们将尽力协助您找回行李。若携带行李超重，逾重部分的收费标准以航司规定为准。</van-col
        >
        <van-col class="title title1" span="24">托运行李</van-col>
        <van-col class="tip1" span="24">{{ luggageInfo }}</van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listObj: {},
      //    mouth_day: "",
      activeClassF: "more",
      activeClass: "complex",
      isiOSX: false,
      cabinList: [],
      child_show: false,
      baby_show: false,
      cabin: 0,
      price_list2: false,
      price_list3: false,
      hascabin: true,
      luggagePop: false,
      luggageInfo: "",
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.listObj = JSON.parse(sessionStorage.getItem("planes"));
    sessionStorage.removeItem("contactInfo");
    if (this.listObj.child_quantity != 0) {
      this.child_show = true;
      this.price_list2 = true;
    }
    if (this.listObj.baby_quantity != 0) {
      this.baby_show = true;
      this.price_list2 = true;
    }
    if (this.listObj.child_quantity != 0 && this.listObj.baby_quantity != 0) {
      this.price_list3 = true;
    }
    this.cabin = this.listObj.cabin;
  },
  methods: {
    luggageRule(info) {
      if (info) {
        let len = info.length;
        if (
          !/^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9_-])$/.test(
            info.substr(len - 2, 1)
          )
        ) {
          this.luggageInfo = info.substr(0, len - 2) + ";";
        } else {
          this.luggageInfo = info;
        }
        this.luggagePop = true;
      }
    },
    closePopup() {
      this.luggagePop = false;
    },
    getCabin() {
      this.$api
        .post("/air/member/booking/cabin/list", {
          flight_nos: this.listObj.flight_no,
          query_id: sessionStorage.getItem("query_id"),
        })
        .then((res) => {
          sessionStorage.setItem("flight_id", res.flight_id);
          if (res.cabin_info && res.cabin_info.length > 0) {
            // this.cabinList = res.cabin_info;
            res.cabin_info.forEach((_) => {
              var person_allow = false;
              var child_allow = false;
              var baby_allow = false;
              _.allow_personnel_info.forEach((item) => {
                if (
                  item.allow_personnel_type == "ADT" &&
                  item.max_count >= 0 &&
                  _.cabin_number > 0
                ) {
                  //必须保证成人舱位有余位
                  person_allow = true;
                }
                if (
                  item.allow_personnel_type == "CHD" &&
                  item.max_count >= 0 &&
                  _.child_cabin_status > 0
                ) {
                  child_allow = true;
                }
                if (
                  item.allow_personnel_type == "INF" &&
                  item.max_count >= 0 &&
                  _.baby_cabin_number > 0
                ) {
                  baby_allow = true;
                }
              });
              if (person_allow) {
                //成人舱位必须有余位
                if (!this.child_show && !this.baby_show) {
                  //不携带儿童和婴儿
                  this.cabinList.push(_);
                } else if (this.child_show && !this.baby_show && child_allow) {
                  //只携带儿童且儿童舱位有余位
                  this.cabinList.push(_);
                } else if (this.baby_show && !this.child_show && baby_allow) {
                  //只携带婴儿且婴儿舱位有余位
                  this.cabinList.push(_);
                } else if (
                  this.child_show &&
                  this.baby_show &&
                  child_allow &&
                  baby_allow
                ) {
                  //携带儿童和婴儿且儿童和婴儿舱位都有余位
                  this.cabinList.push(_);
                }
              }
            });
          } else {
            this.hascabin = false;
          }
          if (this.cabinList.length == 0) {
            this.hascabin = false;
          }
        })
        .catch((err) => {
          this.hascabin = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    //预定
    destine(item) {
      item = {
        price: item,
        info: this.listObj,
      };
      //本地缓存该价格和航班信息
      sessionStorage.setItem("create", JSON.stringify(item));
      sessionStorage.removeItem("passengerLists");
      this.$router.push("/submit/order");
    },
    reBack() {
      this.$router.go(-1);
      //Toast('返回');

      /*this.$router.push({
        name: `planeProblem`
      })*/
    },
    timeCheck(time) {
      var hh = time.slice(11, 16);
      return hh;
    },
    question() {
      this.$router.push({
        path: "/plane/problem",
        query: {
          module: "air",
        },
      });
    },
    getDate(dateTime) {
      var date = new Date(dateTime);
      var mouth = date.getMonth() + 1;
      var day = date.getDate();
      return mouth + "月" + day + "日";
    },
    toHourMinute(minutes) {
      if (Math.floor(minutes / 60) <= 0) {
        return minutes + "分";
      } else {
        return Math.floor(minutes / 60) + "时" + (minutes % 60) + "分";
      }
    },
  },
  mounted() {
    //  this.getDate();
    this.getCabin();
  },
};
</script>

<style lang="less" scoped>
.plane {
  &-detail-page {
    height: 100%;
    background: #f2f2f2;

    .van-popup--bottom {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      height: 352px;
      padding-top: 62px;
      overflow: hidden;
      .close {
        width: 22px;
        text-align: left;
        position: absolute;
        top: 20px;
        left: 15px;
        z-index: 2009;
      }
      .popBox {
        padding: 0 15px;
        height: 100%;
        overflow-y: scroll;
        .title {
          color: #333;
          font-size: 18px;
          text-align: left;
          height: 25px;
          line-height: 25px;
          margin: 6px 0 10px;
          font-weight: 700;
        }
        .tip {
          color: #999;
          font-size: 15px;
          line-height: 23px;
        }
        .title1 {
          font-size: 16px;
          margin-top: 20px;
        }
        .tip1 {
          color: #333;
          font-size: 16px;
          line-height: 25px;
          padding-bottom: 40px;
        }
      }
    }
    .detailTitle {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      padding: 0;
      width: 100%;
      padding-top: 20px;
      height: 50px;
      line-height: 50px;
      background: #f2f2f2;
      .back {
        width: 17px;
        padding: 8px;
        position: fixed;
        top: 33px;
        left: 8px;
        z-index: 9;
      }
      .target {
        padding: 6px 16px;
        text-align: center;
        img {
          width: 30px;
          padding: 5px 6px;
        }
      }
      .que {
        position: fixed;
        top: 26px;
        right: 11px;
        z-index: 9;
        color: #333;
        font-size: 14px;
      }
    }
    .content {
      padding: 76px 11px 0;
      background: #f2f2f2;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .msg {
        padding: 0 10px;
        background: #fff;
        border-radius: 10px;
        margin-bottom: 7px;
        box-shadow: #e3e3e3 2px 0 4px;
        .flex-box {
          display: flex;
          border-bottom: 1px solid #f9f9f9;
        }
        .flight {
          background: #fff;
          font-size: 13px;
          position: relative;
          .title {
            height: 33px;
            line-height: 33px;
            margin-right: 12px;
            color: #333;
            img {
              width: 14px;
              margin-right: 7px;
              float: left;
              margin-top: 9px;
            }
          }
          .middle {
            color: #666;
            text-align: center;
          }
          .right {
            color: #666;
            position: absolute;
            right: 0;
            margin-right: 0;
          }
          .time {
            text-align: center;
            font-size: 21px;
            height: 17px;
            line-height: 17px;
            margin-top: 10px;
            img {
              width: 59px;
              padding-bottom: 7px;
            }
          }
          .space {
            font-size: 13px;
            text-align: center;
            height: 20px;
            line-height: 20px;
            margin-top: 11px;
          }
          .duration {
            color: #666;
            font-size: 11px;
            line-height: 13px;
            text-align: center;
          }
        }
        .tip {
          color: #999;
          font-size: 9px;
          text-align: center;
          height: 29px;
          line-height: 29px;
          margin-bottom: 4px;
          .line {
            height: 10px;
            width: 1px;
            background: #999;
            margin: 0 7px;
            display: inline-block;
          }
        }
      }
      .msg_stop {
        padding: 0 10px;
        background: #fff;
        border-radius: 10px;
        margin-bottom: 7px;
        box-shadow: #e3e3e3 2px 0 4px;
        .title {
          color: #333;
          font-size: 14px;
          height: 34px;
          line-height: 34px;
          margin-bottom: 10px;
          font-weight: bold;
          .date {
            margin-left: 22px;
            font-size: 13px;
          }
          .duration {
            margin-left: 18px;
            font-size: 11px !important;
          }
        }
        .interval {
          padding-left: 58px;
          position: relative;
          .circle {
            width: 3px;
            height: 3px;
            position: absolute;
            left: 0;
            top: 0;
          }
          .box {
            padding-left: 6px;
            height: auto;
            position: relative;
            padding-bottom: 12px;
            .line {
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
            }
            .tit {
              color: #333;
              font-size: 10px;
              height: 16px;
              line-height: 4px;
              font-weight: bold;
              position: relative;
              .time {
                position: absolute;
                top: 0;
                left: -63px;
                font-size: 10px;
                color: #333;
                font-weight: bold;
              }
              .t1 {
                top: -17px;
                color: #e6212f;
                font-size: 8px !important;
              }
            }
            .point {
              color: #999;
              font-size: 10px;
              height: 24px;
              line-height: 22px;
            }
            .info {
              background: #fffaf8;
              border-radius: 3px;
              height: 22px;
              line-height: 22px;
              color: #666;
              font-size: 10px;
              img {
                width: 14px;
                vertical-align: middle;
                margin: 0 7px 0 5px;
              }
            }
          }
          .last {
            padding-bottom: 0;
          }
        }
        .tip {
          height: 14px;
          line-height: 14px;
          margin-bottom: 10px;
        }
      }
      .list {
        background: #fff;
        border-radius: 10px;
        margin-bottom: 7px;
        padding: 0 10px;
        box-shadow: #e3e3e3 2px 0 4px;
        .left {
          .price {
            color: #e6212f;
            font-size: 11px;
            height: 28px;
            line-height: 28px;
            margin-top: 2px;
            span {
              float: left;
            }
            .label {
              margin-top: 2px;
            }
            .money {
              font-size: 18px;
            }
            .style {
              color: #333;
              font-size: 11px;
              margin: 0 10px;
            }
            .return {
              width: 14px;
              height: 14px;
              line-height: 14px;
              text-align: center;
              color: #333;
              font-size: 11px;
              background: #ffc663;
              border-radius: 3px;
              margin-top: 7px;
            }
          }
          .price:first-child {
            margin-top: 7px;
          }
          .tip {
            color: #666;
            font-size: 11px;
            padding: 10px 0 13px;
            b {
              font-weight: normal !important;
            }
            .tickets {
              color: #e6212f;
              font-size: 11px !important;
              padding: 2px 4px;
              text-align: center;
              border: solid 1px #e6212f;
              border-radius: 1px;
              margin-left: 10px;
            }
          }
        }
        .right {
          text-align: right;
          span {
            width: 56px;
            height: 28px;
            line-height: 28px;
            color: #fff;
            font-size: 15px;
            border-radius: 14px;
            display: inline-block;
            text-align: center;
            margin-top: 24px;
            background: -webkit-linear-gradient(
              to right,
              #ed6161,
              #feac7a
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              to right,
              #ed6161,
              #feac7a
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              to right,
              #ed6161,
              #feac7a
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #ed6161, #feac7a);
          }
          .complex {
            margin-top: 39px;
          }
        }
        .more {
          .complex {
            margin-top: 54px;
          }
        }
      }
      .loading {
        text-align: center;
        img {
          width: 35%;
          margin-top: 10%;
        }
      }
      .empty_list {
        padding-top: 31px;
        .emptyMsg {
          padding: 0 93px;
          text-align: center;
          img {
            width: 100%;
            display: block;
          }
          .tip1 {
            color: #b9b9b9;
            font-size: 15px;
            height: 51px;
            line-height: 51px;
            margin-bottom: 12px;
          }
          .btn {
            text-align: center;
            span {
              width: 110px;
              height: 32px;
              line-height: 32px;
              color: #ff6059;
              display: inline-block;
              border: solid 1px rgba(255, 96, 89, 0.4);
              border-radius: 16px;
              box-shadow: rgba(255, 96, 89, 0.1) 3px 0 6px;
            }
          }
        }
      }
    }
  }
}
.isiOSX {
  .detailTitle {
    padding-top: 40px;
    .back {
      top: 53px;
    }
    .que {
      top: 46px;
    }
  }
  .content {
    padding-top: 96px;
  }
}
</style>
